import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import styles from '../RoleDashboard.module.scss';
import { useGlobalContext } from '../../../context/GlobalContext';
import { TOOL_ID } from '../../../actions';
import { fetchMemberQuestionsAction } from '../../../actions/questionsActions';
import { getNotifsAction } from '../../../actions/authActions';
import thumbUpIcon from '../../../assets/images/thumb-up.svg';
import clockIcon from '../../../assets/images/clock.svg';
import lateIcon from '../../../assets/images/late.svg';

const INITIAL_COUNTS = {
  toTreat: 0,
  soonLate: 0,
  late: 0,
};

function computeCounts(questions = []) {
  return questions.reduce((acc, question) => {
    if (question.status === 'resolved') {
      return acc;
    }
    const delay = question.delay ?? 0;
    if (delay >= 7) {
      acc.late += 1;
    } else if (delay >= 5) {
      acc.soonLate += 1;
    } else {
      acc.toTreat += 1;
    }
    return acc;
  }, { ...INITIAL_COUNTS });
}

export default function MemberDashboard() {
  const [context, dispatch] = useGlobalContext();
  const { userAuth } = context.auth;
  const [counts, setCounts] = useState(INITIAL_COUNTS);

  const role = userAuth?.tools?.find((t) => t.tool === TOOL_ID)?.role;
  const isOwner = role === 'Owner';
  const questionsPath = isOwner ? '/question-assign' : '/question-member';
  const firstName = userAuth?.firstName || userAuth?.profile?.firstName || '';

  const initData = useCallback(async () => {
    getNotifsAction(dispatch, 'Medocta');
    const filters = isOwner && userAuth?._id
      ? { assignTo: [userAuth._id] }
      : {};
    let questions = await fetchMemberQuestionsAction(dispatch, filters);
    if (isOwner && userAuth?._id) {
      questions = questions.filter((q) => q.assignTo?._id === userAuth._id);
    }
    setCounts(computeCounts(questions));
  }, [dispatch, isOwner, userAuth?._id]);

  useEffect(() => {
    initData();
  }, [initData]);

  return (
    <div className={`page-container ${styles.container}`}>
      <h1 className={styles.title}>Bonjour {firstName}</h1>
      <div className={styles.cards}>
        <Link to={questionsPath} className={styles.card}>
          <div className={styles.cardContent}>
            <p className={styles.label}>À traiter</p>
            <div className={styles.countRow}>
              <p className={styles.count}>{counts.toTreat}</p>
              <p className={styles.unit}>questions</p>
            </div>
          </div>
          <div className={`${styles.iconWrap} ${styles.toTreat}`}>
            <img src={thumbUpIcon} alt="" />
          </div>
        </Link>

        <Link to={questionsPath} className={styles.card}>
          <div className={styles.cardContent}>
            <p className={styles.label}>Bientôt en retard</p>
            <div className={styles.countRow}>
              <p className={styles.count}>{counts.soonLate}</p>
              <p className={styles.unit}>questions</p>
            </div>
          </div>
          <div className={`${styles.iconWrap} ${styles.soonLate}`}>
            <img src={clockIcon} alt="" />
          </div>
        </Link>

        <Link to={questionsPath} className={styles.card}>
          <div className={styles.cardContent}>
            <p className={styles.label}>En retard</p>
            <div className={styles.countRow}>
              <p className={styles.count}>{counts.late}</p>
              <p className={styles.unit}>questions</p>
            </div>
          </div>
          <div className={`${styles.iconWrap} ${styles.late}`}>
            <img src={lateIcon} alt="" />
          </div>
        </Link>
      </div>
    </div>
  );
}
